export const connectionsApi = {
  list_connections: {
    scope: 'iam.org_cons:r',
    url: () => '/organization/connections',
  },
  create_connection: {
    scope: 'iam.org_cons:w',
    url: () => '/organization/connections',
  },
  get_connection: {
    scope: 'iam.org_cons:r',
    url: (connectionId: string) => `/organization/connections/${connectionId}`,
  },
  delete_connection: {
    scope: 'iam.org_cons:w',
    url: (connectionId: string) => `/organization/connections/${connectionId}`,
  },
  patch_connection: {
    scope: 'iam.org_cons:w',
    url: (connectionId: string) => `/organization/connections/${connectionId}`,
  },
  verify_connection: {
    scope: 'iam.org_cons:w',
    url: (connectionId: string) =>
      `/organization/connections/${connectionId}/verify`,
  },
  activate_connection: {
    scope: 'iam.org_cons:w',
    url: (connectionId: string) =>
      `/organization/connections/${connectionId}/activate`,
  },
  get_claims_mappings: {
    scope: 'identity.org_connections:read',
    url: (connectionId: string) =>
      `/organization/connections/${connectionId}/claimsmapping`,
  },
  put_claims_mappings: {
    scope: 'identity.org_connections:write',
    url: (connectionId: string) =>
      `/organization/connections/${connectionId}/claimsmapping`,
  },
};
